<template lang="html">
    <!--<v-container style="padding-top: 100px;">-->
    <div class="container-fluid">

        <v-row>
            <v-col lg=12 cols=12 style="margin: 0 auto;">
                <v-card>
                    <v-card-title class="pa-5 pb-3 primary">
                        <v-icon class="pr-4" :color="'#FFFFFF'">mdi-plus</v-icon>
                        <p style="color: white;">Movimiento Trámite</p>
                        <v-spacer></v-spacer>
                    </v-card-title>

                    <v-card-text class="pa-5 pt-4">

                        <v-row>
                            <v-col md="6" offset-md="3">
                                <vs-list>
                                    <span style="color: black; text-align: center;">Tipo de Movimiento:</span>
                                    <vs-list-item :title="titleMov">
                                    </vs-list-item>

                                </vs-list>

                            </v-col>
                        </v-row>
                        <v-row v-if="ceclave == 644">
                            <v-col md="6" offset-md="3">
                                <vs-list>

                                    <span style="color: black; text-align: center;">Respuesta:</span>
                                    <v-form ref="form2" v-model="valid1" lazy-validation>
                                        <v-radio-group v-model="checks" :rules="rulescheck" row>
                                            <v-radio label="Sí" required value="S"></v-radio>
                                            <v-radio label="No" required value="N"></v-radio>
                                        </v-radio-group>
                                    </v-form>

                                </vs-list>

                            </v-col>
                        </v-row>
                        <v-form id="Tramites" ref="form3" v-model="valid3" lazy-validation>
                            <v-row class="mb-6" v-if="ceclave == 644"
                                style="margin-bottom: 0px !important; height: 100px;">
                                <v-col md="3" offset-md="3">

                                    <span style="color: black; text-align: center;">Fecha:</span>
                                    <v-dialog ref="dialog" outlined v-model="modal" :return-value.sync="datos.fecha"
                                        persistent width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="fechaV" label="" readonly :rules="rulestextfechas"
                                                outlined dense v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="datos.fecha" :max="maxDateFh" :min="minDateFh"
                                            scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="modal = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog.save(datos.fecha)">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>

                                </v-col>
                                <v-col md="3">
                                    <span style="color: black; text-align: center;">Hora:</span>


                                    <v-dialog ref="dialog1" v-model="modal2" outlined
                                        :return-value.sync="datos.timefecha" persistent width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="datos.timefecha" label="" readonly
                                                :rules="rulestextfechas" outlined dense v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-time-picker v-if="modal2" v-model="datos.timefecha" :max="maxtime"
                                            :min="mintime" format="24hr" ampm-in-title scrollable full-width>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="modal2 = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog1.save(datos.timefecha)">
                                                OK
                                            </v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-col>

                            </v-row>

                            <v-row class="mb-6" v-if="ceclave == 835"
                                style="margin-bottom: 0px !important; height: 100px;">
                                <v-col md="6" offset-md="3">

                                    <span style="color: black; text-align: center;">Fecha del movimiento:</span>
                                    <v-dialog ref="dialog" outlined v-model="modal" :return-value.sync="datos.fecha"
                                        persistent width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="fechaV" label="" readonly :rules="rulestextfechas"
                                                outlined dense v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="datos.fecha" :max="maxDateFh" :min="minDateFh"
                                            scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="modal = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog.save(datos.fecha)">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>

                                </v-col>
                            </v-row>
                        </v-form>


                        <div v-if="ceclave == 835">
                            <v-row>
                                <v-col md="6" offset-md="3">
                                    <v-form ref="form1" v-model="valid2" lazy-validation>
                                        <vs-list v-for="(item, index) in documentos" :key="index">
                                            <span v-if="index == 0"
                                                style="color: black; text-align: center;">Documentos:</span>

                                            <v-checkbox v-model="item.checks" @click="selectCheck(index)"
                                                :label="item.dodescrip"></v-checkbox>

                                            <div v-if="item.show">
                                                <span style="color: black; text-align: center;">Monto:</span>
                                                <v-text-field v-model="item.monto" type="number"
                                                    :rules="rulesinputNumber" min="1" outlined dense>

                                                </v-text-field>
                                            </div>

                                        </vs-list>
                                        <span v-if="validadoctos" class='spanError'
                                            style='color:red;font-size:11px'>Seleccione al menos un
                                            documento</span>
                                    </v-form>
                                </v-col>
                            </v-row>
                        </div>
                        <v-row>
                            <v-col md="6" offset-md="3">
                                <vs-list>
                                    <span style="color: black; text-align: center;">Observaciones:</span>
                                    <v-form ref="form" v-model="valid" lazy-validation>
                                        <v-textarea @input="uppercase()" :counter="500" :rules="rulestextarea" outlined
                                            v-model="datos.comentarios" required name="input-7-4"></v-textarea>
                                    </v-form>
                                </vs-list>
                            </v-col>
                        </v-row>


                        <v-row justify="center" class="mb-8">
                            <v-btn v-if="ceclave == 644" class="ma-2" color="primary" @click="Guardar()"
                                :disabled="disabledSave">
                                Guardar
                            </v-btn>
                            <v-btn v-if="ceclave == 835" class="ma-2" color="primary" @click="GuardarDemerito()"
                                :disabled="disabledSave">
                                Guardar
                            </v-btn>
                            <v-btn v-if="ceclave == 644" class="ma-2" @click="limpiarCampos()" :disabled="disabledSave">
                                Limpiar
                            </v-btn>
                            <v-btn v-if="ceclave == 835" class="ma-2" @click="limpiarCamposDemerito()"
                                :disabled="disabledSave">
                                Limpiar
                            </v-btn>
                            <v-btn class="ma-2" color="error" @click="Cancelar()" :disabled="disabledSave">
                                Cancelar
                            </v-btn>

                        </v-row>
                        <div class="mt-10"><br><br><br><br></div>

                    </v-card-text>

                </v-card>
            </v-col>
        </v-row>
    </div>

    <!--</v-container>-->

</template>

<script>
import { mapGetters, mapState } from 'vuex';
import moment from 'moment'
import seguimiento from '@/services/Seguimiento/seguimiento.service.js';

export default {
    //props: {
    //    nrreporte: '',
    //    svindice: '',
    //    aiclave: 0,
    //    ceclave:0
    //},
    data() {
        return {
            fechaV: '',
            modal: false,
            modal2: false,
            checks: '',
            valid1: true,
            valid3: true,
            valorcheck: 0,
            validadoctos: false,
            valid2: true,
            checkbox: false,
            titleMov: '',
            valid: true,
            rulescheck: [v => !!v || 'Seleccione respuesta'],
            rulestextarea: [v => !!v || 'Campo requerido',
            v => {
                if (v == null) {
                    return true
                }
                else {
                    // return 'Mínimo 12 Carácteres'

                    if (v.length < 12) {
                        return 'Mínimo 12 Carácteres'
                    }
                    else if (v.length > 500) {
                        return 'Máximo 500 Carácteres'
                    }
                    else
                        return true
                }
            },
                //v => {
                //    if (v == null) {
                //        return true
                //    }
                //    else {
                //        if (v.length >= 500)
                //            return 'Máximo 500 Carácteres'
                //        else
                //            return true

                //    }
                //},
            ],
            rulesinputNumber: [val => {
                if (val < 200 || val > 50000) return 'Escriba un monto valido entre (200 y 50000) pesos'
                return true
            },
            val => /^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/.test(val) || 'Escriba un monto valido'
            ],
            validafecha: false,
            maxDateFh: '',
            minDateFh: '',
            disabledSave: false,
            datos: {
                fecha: '',
                timefecha: '',
                comentarios: ''
            },
            mintime: '',
            maxtime: '',
            rulestextfechas: [v => !!v || 'Campo requerido'],
            fechaactual: '',
            documentos: [],
            nrreporte: 0,
            svindice: 0,
            aiclave: 0,
            ceclave: 0,
            fecha: '',
            back: 0


        }
    },
    watch: {

        async 'datos.fecha'(val) {

            this.validafecha = false;
            if (val != null && val != '') {
                //this.validafecha = true;
                let theDate = moment(val).format('ll');
                this.fechaV = theDate;
            }
            if (this.ceclave == 644) {
                var dateA = moment(this.datos.fecha);
                var dateB = moment(this.maxDateFh);

                if (dateB.diff(dateA) < 0) {
                    this.datos.fecha = this.maxDateFh;

                }
            }

        },

    },


    computed: {
        ...mapGetters(['getUser', 'THEME_STATE']),
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage', 'permission']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    methods: {
        selectCheck(index) {
            if (this.documentos[index].checks) {
                this.documentos[index].show = true;
                this.validadoctos = false;
                this.valorcheck++;
            }
            else {
                this.documentos[index].show = false;
                this.documentos[index].monto = '';
                this.valorcheck--;
                if (this.valorcheck == 0) {
                    this.validadoctos = true;
                }
            }
        },
        GuardarDemerito() {
            this.disabledSave = true;
            this.datos.comentarios = this.datos.comentarios.trim();

            this.$refs.form1.validate();
            this.$refs.form.validate();
            this.$refs.form3.validate();


            let mensajefecha = this.datos.fecha == '' ? 'Seleccione la Fecha</br></br>' : '';



            if (this.$refs.form1.validate() && this.$refs.form.validate() && mensajefecha == '' && this.valorcheck > 0 && this.datos.comentarios.length >= 12 && this.$refs.form3.validate()) {

                this.$swal({
                    position: 'center',
                    title: 'Guardando movimiento, espere un momento....',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                seguimiento.tramiteGuardarMovimientoDemerito(this).then(response => {

                    setTimeout(() => {

                        this.$swal.close();

                        if (response) {

                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se guardó el movimiento con éxito.',
                                showConfirmButton: true,
                                timer: 3000
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.back = 1;
                                    this.limpiarCamposDemerito();
                                    this.disabledSave = false;
                                    //this.$emit("cambioTramite", true);
                                    this.$router.push({ name: 'ReporteSeguimientoGD' });
                                }
                            })

                            setTimeout(() => {
                                if (this.back == 0) {
                                    this.limpiarCamposDemerito();
                                    this.disabledSave = false;
                                    this.$router.push({ name: 'ReporteSeguimientoGD' });
                                }


                            }, 4000);
                        }

                    }, 2000);




                });
            }
            else {
                this.disabledSave = false;
                if (mensajefecha != '') {
                    this.validafecha = true;
                }
                if (this.valorcheck == 0) {
                    this.validadoctos = true;
                }
            }



        },

        Guardar() {
            this.disabledSave = true;
            this.datos.comentarios = this.datos.comentarios.trim();
            this.$refs.form2.validate();
            this.$refs.form3.validate();
            this.$refs.form.validate();

            let mensajeComentario = this.datos.comentarios.length < 12 || this.datos.comentarios.length > 500 ? 'null' : '';


            if (this.valid == true && mensajeComentario == '' && this.datos.fecha != '' && this.datos.comentarios.length >= 12 && this.$refs.form2.validate() && this.$refs.form3.validate()) {

                this.fecha = this.datos.fecha + ' ' + this.datos.timefecha;

                this.$swal({
                    position: 'center',
                    title: 'Guardando movimiento, espere un momento....',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                seguimiento.tramiteGuardarMovimiento(this).then(response => {


                    setTimeout(() => {

                        this.$swal.close();
                        if (response) {

                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se guardó el movimiento con éxito.',
                                showConfirmButton: true,
                                timer: 3000
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.back = 1;
                                    this.limpiarCampos();
                                    this.disabledSave = false;
                                    //this.$emit("cambioTramite", true);
                                    this.$router.push({ name: 'ReporteSeguimientoGD' });
                                }
                            })

                            setTimeout(() => {
                                if (this.back == 0) {
                                    this.limpiarCampos();
                                    this.disabledSave = false;
                                    this.$router.push({ name: 'ReporteSeguimientoGD' });
                                }


                            }, 4000);


                        }

                    }, 2000);


                });


            }
            else {
                this.disabledSave = false;
                if (this.datos.fecha == '') {
                    this.validafecha = true;
                }

            }


        },
        limpiarCampos() {

            this.$refs.form3.reset();
            this.$refs.form2.reset();
            this.$refs.form.reset();
            this.datos.comentarios = '';
            this.checks = '';
            this.datos.fecha = '';
            this.fechaV = '';

        },
        limpiarCamposDemerito() {
            this.validadoctos = false;
            this.$refs.form3.reset();
            this.$refs.form1.reset();
            this.$refs.form.reset();
            this.datos.comentarios = '';
            this.valorcheck = 0;
            this.datos.fecha = '';
            this.fechaV = '';
            this.documentos.forEach((value, index) => {

                this.documentos[index].checks = false;
                this.documentos[index].monto = '';
                this.documentos[index].show = false;
            });
        },
        Cancelar() {
            //this.$emit("cambioTramite", true);
            this.$router.push({ name: 'ReporteSeguimientoGD' });
        },
        uppercase() {
            if (this.datos.comentarios != '' && this.datos.comentarios != null) {

                this.datos.comentarios = this.datos.comentarios.toUpperCase();
            }

        },


    },
    async mounted() {
        this.nrreporte = this.$route.params.nrreporte;
        this.svindice = this.$route.params.svindice;
        this.aiclave = this.$route.params.aiclave;
        this.ceclave = this.$route.params.ceclave;

        if (this.nrreporte === undefined) {
            this.$router.push({ name: 'ReporteSeguimientoGD' });
        }
        else {

            if (this.ceclave == 644) {
                let res = await MetodosGenerales.obtenerFechaHoraBase();
                let today = res.today;
                this.datos.fecha = today;
                this.fechaactual = today;
                let theDate = moment(today).format('ll');
                this.fechaV = theDate;

                let max = moment().format('HH:mm');
                this.maxtime = max;

                setTimeout(() => {

                    //let date2 = moment().add(1, 'm');
                    this.maxDateFh = today;//date2.format("yyyy-MM-DD hh:mm");

                    //this.maxDateFh = moment().format("yyyy-MM-DD hh:mm");
                    //console.log();
                    this.datos.fecha = today;
                    let date1 = moment().subtract(30, 'm');
                    this.minDateFh = date1.format("yyyy-MM-DD HH:mm");

                    let min = date1.format("HH:mm");
                    this.mintime = min;

                    //let date1 = moment().format("yyyy-MM-DD");
                    //this.minDateFh = date1 + ' 10:20';


                }, 1000);

                //this.maxDateFh = fechad[2] + '-' + fechad[1] + '-' + fechad[0] + ' ' + hours + ':' + minuts;

            }
            else {
                let today = moment().format('YYYY[-]MM[-]DD');
                this.datos.fecha = today;

                let theDate = moment(today).format('ll');
                this.fechaV = theDate;

                let fechad = new Date().toLocaleDateString('en-GB').split('/');
                let hours = new Date().getHours();
                let minuts = new Date().getMinutes();
                if (hours < 10) {
                    hours = "0" + hours;
                }
                if (minuts < 10) {
                    minuts = "0" + minuts;
                }

                this.maxDateFh = fechad[2] + '-' + fechad[1] + '-' + fechad[0] + ' ' + hours + ':' + minuts;

                seguimiento.obtenerDocumentosTramite(this);
            }

            seguimiento.obtenerdatosReporte(this);


        }

    }
}
</script>

<style>
/*#Tramites .v-input__control {*/
/*max-height: 0px;*/
/*max-height: 90%;
        height: 90%;
    }*/

/*  .v-application .mb-6 {
        margin-bottom: 0px !important;
        height: 100px;
    }*/
</style>
